import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const header = document.getElementById('site-header');
const hamburger = document.querySelector('.header__hamburger');
const mobileMenu = document.getElementById('mobile-menu');
const mobileClose = document.querySelector('.header__mobile-close');

if (header) {
  const pinHeader = () => {
    if (header.classList.contains('is-pinned')) {
      return;
    }

    gsap.killTweensOf(header);

    header.classList.add('is-pinned');
    header.classList.add('is-scrolled');

    gsap.fromTo(
      header,
      {
        y: -20,
      },
      {
        y: 0,
        duration: 0.45,
        ease: 'power3.out',
        clearProps: 'transform',
      }
    );
  };

  const unpinHeader = () => {
    if (!header.classList.contains('is-pinned')) {
      return;
    }

    gsap.killTweensOf(header);

    gsap.to(header, {
      y: -14,
      duration: 0.25,
      ease: 'power2.in',
      onComplete: () => {
        header.classList.remove('is-pinned');
        header.classList.remove('is-scrolled');
        gsap.set(header, { clearProps: 'transform' });
      },
    });
  };

  ScrollTrigger.create({
    start: 50,
    onEnter: pinHeader,
    onLeaveBack: unpinHeader,
  });
}

if (hamburger && mobileMenu) {
  const setMenuState = (isOpen) => {
    hamburger.classList.toggle('is-active', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    mobileMenu.classList.toggle('is-open', isOpen);
    mobileMenu.hidden = !isOpen;
    document.body.style.overflow = isOpen ? 'hidden' : '';

    if (isOpen) {
      gsap.from('.header__mobile-nav-list li', {
        y: 20,
        opacity: 0,
        stagger: 0.07,
        duration: 0.4,
      });
    }
  };

  const openMenu = () => setMenuState(true);
  const closeMenu = () => setMenuState(false);

  hamburger.addEventListener('click', () => {
    const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu();
      return;
    }

    openMenu();
  });

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });
}
